import axios from "axios";
const API_URL = "/api/hr";
const HRLogin = async (HRDetails) => {
  const response = await axios.post(API_URL + "/login", HRDetails);
  //(response.data)
  if (response.data) {
    localStorage.setItem("hr", JSON.stringify(response.data));
  }
  return response.data;
};

const registerHR = async (HRDetails) => {
  const response = await axios.post(API_URL + "/register", HRDetails);
  return response.data;
};

const HRLogout = () => {
  localStorage.removeItem("hr");
};
const hrService = {
  HRLogin,
  HRLogout,
  registerHR,
};
export default hrService;
